import React from 'react';
import ReactDOM from 'react-dom';
import { ShieldCheck, Dumbbell, UserRound, IdCard, Lock, ChevronRight, Users } from 'lucide-react';
import './UserSelectModal.css';

const ROLE_META = {
  admin: { label: 'Administrador', icon: <ShieldCheck size={20} />, isAdmin: true },
  coordenador: { label: 'Coordenador', icon: <Users size={20} />, isAdmin: true },
  atleta: { label: 'Atleta', icon: <Dumbbell size={20} />, isAdmin: false },
  treinador: { label: 'Treinador', icon: <UserRound size={20} />, isAdmin: true },
  socio: { label: 'Sócio', icon: <IdCard size={20} />, isAdmin: false },
  user: { label: 'Sócio', icon: <IdCard size={20} />, isAdmin: false },
};

const getPrimaryRole = (roles = [], u = {}) => {
  const lower = (roles || []).map(r => typeof r === 'string' ? r.toLowerCase() : (r.name ? r.name.toLowerCase() : ''));
  if (lower.includes('admin')) return 'admin';
  if (lower.includes('coordenador') || lower.includes('coordinator') || u.hasCoordinatorProfile) return 'coordenador';
  if (lower.includes('treinador') || lower.includes('coach') || u.hasCoachProfile) return 'treinador';
  if (lower.includes('atleta') || u.hasAthleteProfile) return 'atleta';
  if (lower.includes('socio') || u.hasMemberProfile) return 'socio';
  return 'user';
};

const getDashboardLink = (role) => {
  if (role === 'admin') return '/dashboard-admin';
  if (role === 'coordenador') return '/dashboard-coordenador';
  if (role === 'atleta') return '/dashboard-atleta';
  if (role === 'treinador') return '/dashboard-treinador';
  return '/dashboard-socio';
};

const UserSelectModal = ({ isOpen, users, onSelect, onClose }) => {
  if (!isOpen || !users?.length) return null;

  return ReactDOM.createPortal(
    <div className="user-select-overlay" onClick={onClose}>
      <div className="user-select-modal" onClick={(e) => e.stopPropagation()}>
        <div className="mobile-handle"></div>
        <div className="user-select-header">
          <img src="/CDP_logo.png" alt="CDP Logo" />
          <h3>Clube Desportivo Da Póvoa</h3>
          <p>Selecione o perfil com que pretende entrar</p>
        </div>

        <div className="user-select-body">
          {users.map((u) => {
            const role = getPrimaryRole(u.roles || [u.dashboardType], u);
            const meta = ROLE_META[role] || ROLE_META.user;
            const link = getDashboardLink(role);
            const requiresPin = role === 'admin' || role === 'treinador' || meta.isAdmin || Boolean(u.requiresPin);

            return (
              <button
                key={u.id}
                className={`user-option-card${requiresPin ? ' is-privileged' : ''}`}
                onClick={() => onSelect({ user: u, role, link, requiresPin })}
              >
                <div className="option-icon-container">
                  {meta.icon}
                </div>
                <div className="option-content">
                  <div className="option-name">{u.firstName} {u.lastName}</div>
                  <div className="option-role-container">
                    <span className="option-role-label">{meta.label}</span>
                    {requiresPin && (
                      <span className="privileged-badge" style={{ display: 'flex', alignItems: 'center', gap: '3px' }}>
                        <Lock size={10} /> PIN
                      </span>
                    )}
                  </div>
                </div>
                <ChevronRight className="option-arrow" size={18} />
              </button>
            );
          })}
        </div>
      </div>
    </div>,
    document.body
  );
};

export default UserSelectModal;
